import { getTicketSeats } from './seatConflictUtils';

/** Sale / sale.tickets icinden koltuk id'lerini cikar */
export function collectSaleSeatIds(sale) {
  const ids = new Set();
  const tickets = Array.isArray(sale?.tickets) ? sale.tickets : [];
  tickets.forEach((t) => {
    getTicketSeats(t).forEach((s) => {
      if (s?.id != null) ids.add(String(s.id));
    });
  });
  // bazi kayitlarda details.seats
  const detailSeats = sale?.details?.seats;
  if (Array.isArray(detailSeats)) {
    detailSeats.forEach((s) => {
      if (s?.id != null) ids.add(String(s.id));
      else if (typeof s === 'string') ids.add(s);
    });
  }
  return ids;
}

export function getSaleOrderId(sale) {
  if (!sale || typeof sale !== 'object') return null;
  return (
    sale.payment?.transaction?.orderid ||
    sale.payment?.transaction?.orderId ||
    sale.payment?.orderid ||
    sale.payment?.orderId ||
    sale.oid ||
    sale.extras?.orderid ||
    sale.extras?.orderId ||
    null
  );
}

/**
 * Koltuk + (opsiyonel) seatSelections.user ile eslesen satislar.
 * once koltuk eslesmesi, sonra user eslesmesi.
 */
export function findSalesForSeat({ sales = [], seatId, userId } = {}) {
  if (!seatId) return [];
  const matches = [];

  (sales || []).forEach((sale) => {
    if (!sale) return;
    const seatIds = collectSaleSeatIds(sale);
    const bySeat = seatIds.has(String(seatId));
    const saleUserId =
      sale.user && typeof sale.user === 'object' ? sale.user.id : sale.user;
    const byUser =
      userId && saleUserId && String(saleUserId) === String(userId);

    if (!bySeat && !byUser) return;

    const ticketWithSeat = (Array.isArray(sale.tickets) ? sale.tickets : []).find((t) =>
      getTicketSeats(t).some((s) => String(s.id) === String(seatId)),
    );

    matches.push({
      sale,
      matchType: bySeat ? 'seat' : 'user',
      saleId: sale.id,
      oid: sale.oid || null,
      orderId: getSaleOrderId(sale),
      paymentId: sale.payment?.id || null,
      status: sale.status ?? null,
      channel: sale.channel || null,
      paymentTotal: sale.paymentTotal ?? sale.payment?.total ?? null,
      user: sale.user || null,
      ticketTemplate: ticketWithSeat || (Array.isArray(sale.tickets) ? sale.tickets[0] : null),
    });
  });

  matches.sort((a, b) => {
    if (a.matchType !== b.matchType) return a.matchType === 'seat' ? -1 : 1;
    return Number(b.status === 1) - Number(a.status === 1);
  });

  return matches;
}
